/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var CancellationToken = /** @class */ (function () {
    function CancellationToken() {
        this.cancelled = false;
    }
    CancellationToken.prototype.isCancelled = function () {
        return this.cancelled === true;
    };
    CancellationToken.prototype.cancel = function () {
        this.cancelled = true;
    };
    return CancellationToken;
}());
export { CancellationToken };
var CancellationTokenSource = /** @class */ (function () {
    function CancellationTokenSource() {
        this.token = new CancellationToken();
    }
    CancellationTokenSource.prototype.cancel = function () {
        this.token.cancel();
    };
    return CancellationTokenSource;
}());
export { CancellationTokenSource };
